// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oops-gem-container {
  flex-wrap: nowrap;
}

.date-picker-calendar {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
  padding: 10px;
  min-width: 180px;
}
.date-picker-calendar .calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.date-picker-calendar .calendar-header button {
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
}
.date-picker-calendar .calendar-header button svg {
  width: 20px;
  height: 20px;
}
.date-picker-calendar .calendar-header .month-year {
  display: flex;
  gap: 5px;
}
.date-picker-calendar .calendar-header .month-year select {
  padding: 5px;
  border: 1px solid #eee;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
}
.date-picker-calendar .calendar-table {
  width: 100%;
  border-collapse: collapse;
}
.date-picker-calendar .calendar-table thead th {
  text-align: center;
  padding: 5px;
  font-size: 12px;
  color: #777;
}
.date-picker-calendar .calendar-table tbody tr td {
  padding: 8px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid transparent;
  background-clip: padding-box;
  line-height: 1.1;
}
.date-picker-calendar .calendar-table tbody tr td.today {
  box-shadow: inset 0 0 0 2px #7a4c4c;
}
.date-picker-calendar .calendar-table tbody tr td.selectedDay {
  background-color: #cf110b;
  color: white;
}
.date-picker-calendar .calendar-table tbody tr td.disabled {
  color: #ccc;
  cursor: not-allowed;
}
.date-picker-calendar .calendar-table tbody tr td.flight-available {
  box-shadow: inset 0 0 0 1px #b70f0a;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ui/forms/inputs/oops-gem-datepicker/oops-gem-datepicker.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;AACR;AAGI;EACE,aAAA;EACA,QAAA;AADN;AAGM;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AADR;AAME;EACE,WAAA;EACA,yBAAA;AAJJ;AAOM;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AALR;AAWQ;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,gBAAA;AATV;AAUU;EACE,mCAAA;AARZ;AAWU;EACE,yBAAA;EACA,YAAA;AATZ;AAYU;EACE,WAAA;EACA,mBAAA;AAVZ;AAaU;EACE,mCAAA;AAXZ","sourcesContent":[".oops-gem-container {\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.date-picker-calendar {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  z-index: 10;\r\n  padding: 10px;\r\n  min-width: 180px;\r\n\r\n  .calendar-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n\r\n    button {\r\n      background: none;\r\n      border: none;\r\n      padding: 5px;\r\n      cursor: pointer;\r\n\r\n      svg {\r\n        width: 20px;\r\n        height: 20px;\r\n      }\r\n    }\r\n\r\n    .month-year {\r\n      display: flex;\r\n      gap: 5px;\r\n\r\n      select {\r\n        padding: 5px;\r\n        border: 1px solid #eee;\r\n        border-radius: 3px;\r\n        font-size: 14px;\r\n        cursor: pointer;\r\n      }\r\n    }\r\n  }\r\n\r\n  .calendar-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    \r\n    thead {\r\n      th {\r\n        text-align: center;\r\n        padding: 5px;\r\n        font-size: 12px;\r\n        color: #777;\r\n      }\r\n    }\r\n\r\n    tbody {\r\n      tr {\r\n        td {\r\n          padding: 8px;\r\n          text-align: center;\r\n          cursor: pointer;\r\n          font-size: 14px;\r\n          border-radius: 4px;\r\n          border: 1px solid transparent;\r\n          background-clip: padding-box;\r\n          line-height: 1.1;\r\n          &.today {\r\n            box-shadow: inset 0 0 0 2px #7a4c4c;\r\n          }\r\n\r\n          &.selectedDay {\r\n            background-color: #cf110b;\r\n            color: white;\r\n          }\r\n\r\n          &.disabled {\r\n            color: #ccc;\r\n            cursor: not-allowed;\r\n          }\r\n          \r\n          &.flight-available {\r\n            box-shadow: inset 0 0 0 1px #b70f0a;\r\n          }\r\n        }\r\n        \r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// oops-gem-datepicker td.flight-available  {\r\n//   box-shadow: inset 0 0 0 1px #b70f0a;\r\n//   background-color: #fff;\r\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
